var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.componentClass, style: _vm.componentStyle }, [
    _c(
      "article",
      {
        class: `card roomy ${_vm.theme}`,
        staticStyle: {
          "--link-color": "var(--fa-dk-blue)",
          "--link-hover-color": "var(--fa-blue)",
        },
      },
      [
        _c(
          "div",
          { staticClass: "header padding-y-4xl" },
          [_c("owa-sample-spinner", { attrs: { size: "4x" } })],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "section text-left" }, [
          _c("h1", { staticClass: "h4 margin-bottom-md" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " + _vm._s(_vm.content) + " Taking too long?\n        "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "mailto:hello@fontawesome.com?subject=A page won't load, Font Awesome",
                },
                on: {
                  click: function ($event) {
                    return _vm.supportLinkClicked("page_loading")
                  },
                },
              },
              [_vm._v("Let us know")]
            ),
            _vm._v("!\n      "),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }